import { render, staticRenderFns } from "./bgiBrandAction.vue?vue&type=template&id=a44d11e8&scoped=true"
import script from "./bgiBrandAction.vue?vue&type=script&lang=js"
export * from "./bgiBrandAction.vue?vue&type=script&lang=js"
import style0 from "./bgiBrandAction.vue?vue&type=style&index=0&id=a44d11e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44d11e8",
  null
  
)

export default component.exports